import React from 'react';
import {Text, TextMessage} from 'components/tt-forms/common';
import {Link, browserHistory} from 'react-router';
import moment from 'moment';
import {ContainerFileDinhKem} from 'components/upload';

class KetQuaGiaiQuyetDonCanBoNhapLieu extends React.Component {
  onClickClose() {
    if (typeof this.props.handleBack == 'function') {
      this.props.handleBack();
    } else {
      browserHistory.goBack();
    }
  }

  render() {
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    return (
      <section className="wrap-block">
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <Text className="col-25 mb15" label={"Đơn vị "+lb1+":"} value={(this.props.donViThamTraXacMinhInfo) ? this.props.donViThamTraXacMinhInfo.ten : ''}/>
            <Text className="col-25 mb15" label="Thời gian báo cáo kết quả:" red={true} value={(this.props.ngayHetHanTTXM) ? moment(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
          </div>
          <TextMessage className="col-100" label="Ý kiến xử lý:" value={this.props.yKienGiaiQuyet ? this.props.yKienGiaiQuyet : ''}/>
          <div className="col-100 pb5">
            <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </section>
    );
  }
}

export default KetQuaGiaiQuyetDonCanBoNhapLieu;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaGiaiQuyetDonCanBoNhapLieu.jsx